$(document).on('submit', 'form.api_key_form', (event) => {
  const data = $(event.target).serializeArray();

  let errors = false;
  event.preventDefault();
  $('.form-error').addClass('hidden');

  data.forEach((field) => {
    if (field.name === 'reason' && field.value.trim() === '') {
      $('.form-error').removeClass('hidden');
      errors = true;
    }
  });

  if (!errors) {
    window.doServerCall(data as any as ContentMap, () => $('#api_key_request_modal').hide());
  }
});
